import { rootUrl } from "../../services/routes.js";
import { createFuncDef } from "../../services/utils/index.js";

export default history => createFuncDef(() => history.push(rootUrl()));
